export class Constants {
  public static readonly DateRangePlaceholderText = 'mm/dd/yyyy - mm/dd/yyyy';
  public static readonly TaxIdRegex = new RegExp(/^\d{2}-\d{7}$/);
  public static readonly ExcelExportKey = 'xlsx';
  public static readonly CsvExportKey = 'csv';
  public static readonly DocStatusOpen = 'opened';
  public static readonly DocRequestOpened = 'request opened';
  public static readonly DocReplyOpened = 'reply opened';
  public static readonly DocReplySent = 'reply sent';
  public static readonly DocRequestSent = 'request sent';
  public static readonly DocStatusReplyInProgress = 'reply in progress';
  public static readonly DocRequestDownloadBySender =
    'request downloaded by sender';
  public static readonly DocRequestDownloadByRecipient =
    'request downloaded by recipient';
  public static readonly DocStatusReplyDownloadBySender =
    'reply downloaded by sender';
  public static readonly DocStatusReplyDownloadByRecipient =
    'reply downloaded by recipient';
  public static readonly DocStatusDownloadedByRecipient =
    'downloaded by recipient';
  public static readonly DocStatusDownloadedBySender = 'downloaded by sender';
  public static readonly DocStatusAutoDelete = 'auto delete';
  public static readonly DocStatusRevisedAutoDeleteDate =
    'revised auto delete date';
  public static readonly DocStatusDeletedBySender = 'deleted by sender';
  public static readonly DocStatusDeletedByRecipient = 'deleted by recipient';
  public static readonly IsReAuthenticatedClaim = 'isReAuthenticated';
  public static readonly NameAndId = 'NameAndId';
  public static readonly Name = 'Name';
  public static readonly Id = 'Id';
  public static readonly NoAdminAlertMessage = 'No Active Admins for this FI';
}

export class TextKeyConstants {
  public static readonly SEFooterInfo = 'SecureExchange_FooterInfo';
  public static readonly SEPreviewInfo = 'SecureExchange_PreviewInfo';
  public static readonly SEAutoSaveInfo = 'SecureExchange_AutoSaveInfo';
  public static readonly SEDouSignPreviewInfo =
    'SecureExchange_Docusign_Preview_Message';
  public static readonly SEAutoDeleteInfo = 'SecureExchange_AutoDeleteInfo';
  public static readonly SEActivityInfo = 'SecureExchange_Activity_Message';
  public static readonly OptInOptOutInfo = 'OptIn_OptOut_Info';
  public static readonly CellPhoneInfo = 'Cell_Phone_Info';
  public static readonly OTPInfo = 'OTP_Info';
  public static readonly SMS_Consent_Info = 'SMS_Consent_Info';
  public static readonly VerificationPendingInfo = 'Verification_Pending_Info';
  public static readonly DeleteInfo = 'Delete_CellPhone_MSG';
  public static readonly CreatePostSuccessMessage =
    'ACH_Network_Success_Message';
  public static readonly ResetPostMessage = 'ACH_Network_Post_Reset_Message';
  public static readonly CancelMessage = 'Cancel_Message';
  public static readonly ACH_Network_Modification_Message =
    'ACH_Network_Modification_Message';
  public static readonly ACH_Network_Post_Message = 'ACH_Network_Post_Message';
  public static readonly ACH_Network_Delete_Post_Message =
    'ACH_Network_Delete_Post_Message';
  public static readonly ACH_Network_Post_Deleted_Message =
    'ACH_Network_Post_Deleted_Message';
  public static readonly UnlockAlertMessage = 'Unlock_Alert_Message';
  public static readonly MarkasCompleteSuccess = 'Mark_as_Complete_Success';
  public static readonly UnlockSuccessMessage = 'Unlock_Success_Message';
  public static readonly ReminderSentMessage = 'Reminder_Sent_Message';
  public static readonly ReminderAlertMessage = 'Reminder_Alert_Message';
  public static readonly ProofOfAuditSubmitResponseMessage =
    'ProofOfAudit_Submit_Response_Message';
  public static readonly ProofOfAuditSubmitRepsonseSuccessMessage =
    'ProofOfAudit_Submit_Repsonse_Success_Message';
  public static readonly ProofOfAuditSendWarningMessage =
    'ProofOfAudit_Send_Warnig_Message';
  public static readonly ProofOfAuditSendSuccessMessage =
    'ProofOfAudit_Send_Success_Message';
  public static readonly ProofOfAuditSaveSuccessMessage =
    'ProofOfAudit_Save_Success_Message';
}

export class ErrorMessageKeyConstants {
  public static readonly SEDeleteDraftWarning = 'Delete_Draft_Exchange_Warning';
  public static readonly SEDeleteInboxWarning =
    'Delete_Inbox_Send_Exchange_Warning';
  public static readonly SEDeleteWarningTitle = 'Delete_Text';
  public static readonly SEDeleteSuccessMessage =
    'SecureExchange_Delete_Success_Message';
  public static readonly SESendSuccessMessage =
    'SecureExchange_Wizard_Send_Success';
  public static readonly SESenderWizardDocusignInfo =
    'SecureExchange_Wizard_Docusign_Info_Message';
  public static readonly SESenderWizardDocusignSaveMessge =
    'SecureExchange_Wizard_Docusign_Save_Message';
  public static readonly SESenderWizardDocusignUnsavedMessge =
    'SecureExchange_Wizard_Docusign_Unsaved_Message';
  public static readonly SESenderWizardSaveMessge =
    'SecureExchange_Wizard_Save_Message';
  public static readonly SESenderWizardCancelMessge =
    'SecureExchange_Wizard_Cancel_Message';
  public static readonly SESenderWizardSendMessge =
    'SecureExchange_Wizard_Send_Message';
  public static readonly SESenderDocusignRecipientsUpdatedMessage =
    'SecureExchange_Wizard_Docusign_Recipient_Update_Message';
  public static readonly SESenderSearchRecipientsMessage =
    'SecureExchange_Wizard_Search_Message';
}

export class ProofOfAuditConstants {
  public static readonly All = 'All';
  public static readonly Sent = 'Sent';
  public static readonly TakeAction = 'Take Action';
  public static readonly MarkAsComplete = 'Mark as Complete';
  public static readonly Completed = 'Completed';
  public static readonly Unlock = 'Unlock';
  public static readonly UnlockAlertText = 'Unlock Request';
  public static readonly MarkedAsCompleted = 'Marked as Completed';
  public static readonly New = 'New';
  public static readonly Opened = 'Opened';
  public static readonly FITakeAction = 'FI Take Action';
  public static readonly CATakeAction = 'CA Take Action';
  public static readonly CompletedByCA = 'Completed by CA';
  public static readonly ProofOfAuditAccessEnabledKey =
    'ProofOfAuditAccessEnabled';
}
export class ModuleConfigConstants {
  public static readonly AchBoardAccessEnabledKey = 'AchBoardAccessEnabled';
}
export class CellPhoneConstants {
  public static readonly ODFIPreferenceContent =
    'ODFI Cell Phone Preference Content';
  public static readonly RDFIPreferenceContent =
    'RDFI Cell Phone Preference Content';
  public static readonly PAPreferenceContent =
    'PA Cell Phone Preference Content';
  public static readonly AchOperatorPreferenceContent =
    'ACH Operator Cell Phone Preference Content';
}
